module.exports = __webpack_public_path__ + "img/id-4-1024x680.1618423e.png";